'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-6ecf82ef.js');

var _extends_1 = _commonjsHelpers.createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

exports._extends_1 = _extends_1;
//# sourceMappingURL=extends-733dd656.js.map
